import type { Dictionary } from "./translations";

export const es: Dictionary = {
  "meta.title": "AgentBuck - Compara precios de modelos de IA",
  "meta.description": "Compara precios de API de los principales modelos de IA y estima los costes mensuales según tu uso real de tokens.",
  "nav.prices": "Precios de modelos",
  "nav.calculator": "Calculadora de costes",
  "nav.providers": "Proveedores",
  "nav.guide": "Guía de precios",
  "nav.method": "Metodología",
  "aria.home": "Inicio de AgentBuck",
  "aria.language": "Seleccionar idioma",
  "aria.navigation": "Navegación principal",
  "aria.breadcrumb": "Ruta de navegación",
  "aria.dark": "Activar modo oscuro",
  "aria.light": "Activar modo claro",
  "title.dark": "Modo oscuro",
  "title.light": "Modo claro",
  "hero.eyebrow": "Base de precios de API de IA",
  "hero.title": "Encuentra el modelo de IA adecuado para tu presupuesto",
  "hero.subtitle": "Compara precios de entrada, salida y caché con una misma base y estima el coste mensual según tu uso real de tokens.",
  "stats.models": "Modelos comparables",
  "stats.providers": "Proveedores principales",
  "stats.updated": "Datos actualizados",
  "common.loading": "Cargando",
  "notice.snapshot": "Los datos en directo no están disponibles. Se muestran los datos locales del 7 de septiembre de 2026.",
  "common.retry": "Reintentar",
  "common.home": "Inicio",
  "common.models": "Modelos",
  "common.providers": "Proveedores",
  "common.from": "Desde",
  "common.viewAll": "Ver todos",
  "common.backPricing": "Volver a los precios",
  "share.quick": "Compartir esta página",
  "share.kicker": "Comparte con tu equipo",
  "share.title": "Compartir esta comparación",
  "share.description": "Envía esta página con los modelos y los supuestos de uso exactos.",
  "share.copy": "Copiar enlace",
  "share.copied": "Enlace copiado",
  "share.more": "Compartir",
  "share.openComparison": "Abrir página compartida",
  "share.email": "Correo electrónico",
  "calculator.title": "Calculadora de coste mensual",
  "calculator.input": "Entrada mensual",
  "calculator.output": "Salida mensual",
  "calculator.cache": "Proporción de entrada en caché",
  "calculator.million": "millones de tokens",
  "calculator.cheapest": "Los 5 modelos más baratos ahora",
  "calculator.perMonth": "Estimación / mes",
  "prices.title": "Precios de modelos",
  "prices.subtitle": "API estándar en tiempo real, USD por millón de tokens",
  "filter.open": "Filtros",
  "filter.search": "Buscar modelos o proveedores",
  "filter.clearSearch": "Borrar búsqueda",
  "filter.provider": "Filtrar por proveedor",
  "filter.allProviders": "Todos los proveedores",
  "filter.sort": "Ordenar modelos",
  "filter.favorite": "Guardados",
  "sort.monthly": "Coste mensual estimado",
  "sort.input": "Precio de entrada",
  "sort.output": "Precio de salida",
  "sort.context": "Ventana de contexto",
  "sort.newest": "Lanzamientos recientes",
  "cap.reasoning": "Razonamiento",
  "cap.tools": "Llamadas a herramientas",
  "cap.vision": "Visión",
  "cap.structured": "Salida estructurada",
  "cap.openWeights": "Pesos abiertos",
  "results.found": "{count} modelos encontrados",
  "results.source": "Tarifas normalizadas a partir de precios publicados. Consulta la documentación del proveedor para verificarlas.",
  "column.compare": "Comparar",
  "column.model": "Modelo / proveedor",
  "column.input": "Entrada",
  "column.cached": "Entrada en caché",
  "column.output": "Salida",
  "column.monthly": "Estimación mensual",
  "column.context": "Contexto",
  "column.capabilities": "Razon.  Herram.  Visión",
  "column.actions": "Acciones",
  "action.officialDocs": "Documentación oficial",
  "action.addCompare": "Añadir a la comparación",
  "action.removeCompare": "Quitar de la comparación",
  "action.addFavorite": "Guardar modelo",
  "action.removeFavorite": "Quitar modelo guardado",
  "action.added": "Añadido",
  "context.suffix": "de contexto",
  "empty.title": "No hay modelos coincidentes",
  "empty.description": "Prueba otra búsqueda o elimina los filtros de capacidades.",
  "empty.clear": "Borrar filtros",
  "home.exploreKicker": "Explora el catálogo",
  "home.exploreTitle": "Más formas de comparar modelos de IA",
  "home.providersTitle": "Explorar por proveedor",
  "home.providersBody": "Compara todos los modelos disponibles de OpenAI, Anthropic, Google, DeepSeek, Alibaba y otros.",
  "home.guideTitle": "Lee la guía de precios",
  "home.guideBody": "Comprende la distribución de tokens, la caché de prompts, los niveles de contexto y los factores que cambian la factura final de la API.",
  "home.open": "Abrir",
  "providers.kicker": "Directorio de proveedores",
  "providers.title": "Proveedores de modelos de IA",
  "providers.intro": "Consulta precios de API normalizados, límites de contexto y capacidades de los principales proveedores del catálogo AgentBuck.",
  "providers.models": "{count} modelos",
  "providers.starting": "Tarifa de entrada mínima",
  "providers.view": "Ver proveedor",
  "provider.kicker": "Precios del proveedor",
  "provider.titleSuffix": "Precios de API",
  "provider.description": "Compara {count} modelos de {name} por precio de entrada, precio de salida, ventana de contexto y capacidades para producción.",
  "provider.cheapest": "Entrada más barata",
  "provider.largestContext": "Mayor contexto",
  "provider.updated": "Catálogo actualizado",
  "model.kicker": "Detalle de precios del modelo",
  "model.title": "Precios de API de {name}",
  "model.descriptionFallback": "Compara tarifas de tokens de API, límites de contexto, capacidades y coste mensual estimado de este modelo.",
  "model.input": "Entrada / 1 M de tokens",
  "model.cache": "Entrada en caché / 1 M",
  "model.output": "Salida / 1 M de tokens",
  "model.context": "Ventana de contexto",
  "model.maxOutput": "Salida máxima",
  "model.released": "Lanzamiento",
  "model.updated": "Modelo actualizado",
  "model.estimateTitle": "Tu estimación mensual",
  "model.estimateBody": "Basada en {input} M de entrada, {output} M de salida y {cache}% de entrada en caché.",
  "model.relatedTitle": "Más modelos de {provider}",
  "compare.pageTitle": "Comparación compartida de costes de IA",
  "compare.pageBody": "Compara tarifas de tokens, ventanas de contexto, capacidades y coste mensual con los supuestos guardados en esta URL.",
  "compare.emptyTitle": "No hay modelos en esta comparación",
  "compare.emptyBody": "Elige dos o tres modelos de la tabla de precios para crear una comparación que puedas compartir.",
  "compare.start": "Elegir modelos",
  "compare.usage": "Carga de trabajo compartida",
  "notFound.title": "Página no encontrada",
  "notFound.body": "Es posible que la página se haya movido o que el modelo ya no esté en el catálogo actual.",
  "guide.kicker": "Guía práctica de compra",
  "guide.title": "Compara precios de API de IA para tu carga de trabajo real",
  "guide.intro": "La tarifa de entrada más baja no siempre produce la factura total más baja. AgentBuck combina los costes de prompts, prompts en caché y tokens generados para evaluar GPT, Claude, Gemini, DeepSeek, Qwen, Grok y otros modelos con la misma carga de trabajo.",
  "guide.inputTitle": "Empieza por tu distribución de tokens",
  "guide.inputBody": "Los chatbots suelen consumir más entrada que salida. Los agentes de programación y los sistemas de razonamiento pueden generar mucha más salida, lo que cambia el modelo más rentable.",
  "guide.cacheTitle": "Incluye la caché de prompts",
  "guide.cacheBody": "Los prompts de sistema repetidos y los contextos compartidos largos pueden hacer decisivo el precio de lectura de caché. Define una proporción de caché realista antes de comparar los totales mensuales.",
  "guide.fitTitle": "Comprueba capacidades y contexto",
  "guide.fitBody": "El precio solo importa si el modelo satisface tus requisitos de ventana de contexto, entrada visual, razonamiento, salida estructurada y llamadas a herramientas.",
  "faq.kicker": "Preguntas frecuentes",
  "faq.title": "Preguntas sobre precios de modelos de IA",
  "faq.q1": "¿Cómo compara AgentBuck los precios de API de modelos de IA?",
  "faq.a1": "AgentBuck normaliza las tarifas estándar de API en tiempo real a dólares por millón de tokens y separa entrada, entrada en caché y salida. Incluye enlaces a la documentación de los proveedores para verificarlas.",
  "faq.q2": "¿Qué modelo de IA tiene la API más barata?",
  "faq.a2": "No hay un modelo más barato en todos los casos. Depende de la proporción entre entrada y salida, el uso de caché y las capacidades necesarias. Introduce tu uso mensual arriba para ordenar los modelos según tu carga de trabajo.",
  "faq.q3": "¿Cómo se calcula el coste mensual estimado de un LLM?",
  "faq.a3": "La estimación multiplica los volúmenes de entrada sin caché, entrada en caché y salida por las tarifas correspondientes de cada modelo. No incluye impuestos, descuentos por lotes, precios regionales ni recargos por contexto largo.",
  "faq.q4": "¿Por qué un modelo puede mostrar un precio de cero dólares?",
  "faq.a4": "Algunos proveedores ofrecen acceso gratuito o promocional a modelos específicos. La disponibilidad y los límites pueden cambiar; verifica la documentación enlazada antes de usar el modelo en producción.",
  "faq.q5": "¿Cómo de actuales son los datos de precios?",
  "faq.a5": "AgentBuck actualiza su catálogo estructurado cada seis horas. La tabla muestra la actualización de modelo más reciente de la fuente, pero la facturación real se rige por las condiciones del proveedor.",
  "method.title": "Datos y metodología",
  "method.priceTitle": "Base de precios",
  "method.priceBody": "Tarifas estándar de API en tiempo real en USD por millón de tokens. No incluyen impuestos, tarifas por lotes, recargos regionales ni niveles de contexto largo.",
  "method.sourceTitle": "Fuente de datos",
  "method.sourceBefore": "Los catálogos públicos de modelos y las páginas de precios de los proveedores se normalizan en un conjunto de datos comparable.",
  "method.sourceAfter": "AgentBuck lo actualiza cada seis horas y enlaza la documentación de los proveedores para su verificación.",
  "method.costTitle": "Estimación de costes",
  "method.costBody": "Coste mensual = entrada normal + entrada en caché + salida. Úsalo para planificar el presupuesto; el panel del proveedor es la referencia oficial de facturación.",
  "footer.tagline": "Haz que cada token cuente.",
  "footer.updated": "Datos actualizados el {date}",
  "compare.selected": "{count}/3 seleccionados",
  "compare.remove": "Quitar {name}",
  "compare.button": "Comparar modelos",
  "compare.kicker": "Comparación de modelos",
  "compare.title": "Precios y capacidades en paralelo",
  "compare.close": "Cerrar",
  "compare.input": "Entrada / MTok",
  "compare.cache": "Caché / MTok",
  "compare.output": "Salida / MTok",
  "compare.monthly": "Coste mensual estimado",
  "compare.context": "Contexto",
  "compare.capabilities": "Razonamiento / herramientas / visión",
  "compare.docs": "Documentación del proveedor",
  "compare.viewPrice": "Ver precios",
  "nav.requestCalculator": "Calculadora de costo por solicitud",
  "home.calculatorTitle": "Estimar costo por volumen de solicitudes",
  "home.calculatorBody": "Calcula el gasto mensual a partir de las solicitudes diarias, los tokens por solicitud y la tasa de aciertos de caché.",
  "home.compareDirectoryTitle": "Ver comparaciones de modelos",
  "home.compareDirectoryBody": "Empieza con una comparación seleccionada o crea la tuya desde la tabla de precios.",
  "model.formulaTitle": "Fórmula de costo",
  "model.formulaBody": "Costo mensual = (tokens de entrada sin caché × tarifa de entrada) + (tokens de entrada en caché × tarifa de lectura de caché) + (tokens de salida × tarifa de salida), todo por millón de tokens. Sin una tarifa de lectura de caché publicada, los tokens en caché se estiman a la tarifa de entrada estándar.",
  "model.exampleTitle": "Ejemplo reproducible",
  "model.exampleBody": "Ejemplo: {inputM} tokens de entrada ({cachePercent}% servidos desde caché) y {outputM} tokens de salida cuestan {total} según las tarifas publicadas de este modelo — {inputRate} entrada, {cacheRate} entrada en caché, {outputRate} salida por millón de tokens.",
  "model.calculatorCta": "Estimar costo por volumen diario de solicitudes",
  "model.comparisonsTitle": "Incluido en estas comparaciones seleccionadas",
};
